import { WIDGET_WALL_DATA_UPDATE, WIDGET_WALL_DATA, WALL_LOAD_REQ, CREATE_N_WALL, } from "./keys";

const initialState = { widgetWallsData: null,wallRequest:false,createNewWall:false }

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case WIDGET_WALL_DATA: { 
            return { ...state, widgetWallsData: action.payload.data };
        }
        case WIDGET_WALL_DATA_UPDATE: {
            let { widgetWallsData } = state;
            let NewWidgetWallData = []
            const { responseData, responseKey, wallid } = action.payload;
            NewWidgetWallData = updateWidgetWall(widgetWallsData, responseData, responseKey, wallid)
            return { ...state, widgetWallsData: NewWidgetWallData }
        }
        case WALL_LOAD_REQ: {
            return { ...state, wallRequest: action.payload }
        }
        case CREATE_N_WALL: {
            return { ...state, createNewWall: action.payload }
        }
        default:
            return { ...state };
    }
}
const updateWidgetWall = (widgetWallsData, responseData, responseKey, wallid) => {
    let wallData = widgetWallsData;
    if (responseKey === 1) {
        widgetWallsData.data.map((item, index) => {
            if (item.id === responseData.id) { wallData.data[index] = responseData }
            return null;
        })
    }
    if (responseKey === 2) {
        wallData.data = widgetWallsData.data.filter((x) => x.id !== wallid);
    }

    if (responseKey === 3) {
        wallData.data.unshift(responseData)
    }


    return wallData;
}